package app.nestbridge.feature.children.screen

import com.karawek.core.circuit.Parcelize
import app.nestbridge.feature.careteam.model.CareTeam
import app.nestbridge.feature.children.model.Child
import app.nestbridge.feature.invitations.model.Invitation
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data class ChildDetailScreen(
    val childId: String,
) : Screen

data class ChildDetailState(
    val child: Child,
    val careTeams: List<CareTeam>,
    val pendingInvitation: Invitation?,
    val isLoading: Boolean,
    val eventSink: (ChildDetailEvent) -> Unit,
) : CircuitUiState

sealed interface ChildDetailEvent {
    data object OnAppear : ChildDetailEvent
    data object Back : ChildDetailEvent
    data object InviteProfessional : ChildDetailEvent
    data object CreateCareTeamMyself : ChildDetailEvent
    data object ViewInvitationQRCode : ChildDetailEvent
    data object CancelInvitation : ChildDetailEvent
}
